import { Input, Table, Tag, message } from 'antd';
import { useLateDeliveriesList } from '../../api/1688-late-delivery/hooks';
import { useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { WarningModal } from './libs/WarningModal';

dayjs.extend(utc);
dayjs.extend(timezone);

const columns = [
    {
        title: 'Трек-код',
        dataIndex: 'trackCode',
        render: (trackCode) => (
            <a
                onClick={() => {
                    navigator.clipboard
                        .writeText(trackCode)
                        .then(() => message.success('Скопировано!'))
                        .catch(() => message.error('Ошибка при копировании'));
                }}
            >
                {trackCode}
            </a>
        ),
    },
    {
        title: 'Статус',
        dataIndex: 'status',
        render: (status) => <Tag color="green">{status}</Tag>,
    },
    {
        title: 'Время создания',
        dataIndex: 'arrivalTime',
        render: (col, _) => {
            const date = new Date(col);
            const formatted = date.toLocaleString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            });

            return <>{formatted}</>;
        },
    },
    {
        title: 'Страна',
        dataIndex: 'country',
        render: (country) => <>{country === 'kg' ? 'Кыргызстан' : 'Казахстан'}</>,
    },
    {
        title: '',
        dataIndex: '',
        render: () => <WarningModal />,
    },
];

export function LateDelivery() {
    const [currentPage, setCurrentPage] = useState(0);
    const { deliveries, isLoading } = useLateDeliveriesList(currentPage);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                padding: '0 40px',
            }}
        >
            <div style={{ marginBottom: '10px', fontSize: '48px' }}>
                <h3 style={{ fontWeight: '200' }}>Задерженные доставки</h3>
            </div>
            <div style={{ display: 'flex', gap: '20px' }}>
                <Input
                    placeholder="Введите трек-код"
                    size="middle"
                    style={{ marginBottom: '20px' }}
                />
                <WarningModal />
            </div>

            <Table
                key={currentPage}
                columns={columns}
                dataSource={deliveries.content || []}
                loading={isLoading}
                style={{ width: '100%' }}
                pagination={{
                    current: deliveries.number + 1,
                    pageSize: deliveries.size,
                    total: deliveries.totalElements,
                    onChange: (page) => {
                        setCurrentPage(page - 1);
                    },
                }}
            />
        </div>
    );
}
